<template>
  <div class="modal-wrapper" @click.self="$emit('close')">
    <div class="modal">
      <header>
        <div>
          <span class="tms">n</span>
          <p>ДОБАВЕТЕ ТРАНСПОРТ</p>
        </div>
        <span class="tms close" @click="$emit('close')">F</span>
      </header>
      <main>
        <div class="row">
          <p>
            <strong>Планирайте транспорт</strong>
          </p>
        </div>
        <section class="rows">
          <template v-if="transports">
            <div class="row" v-for="(t, i) in transports" :key="`row-${i}`">
              <section class="input-wrap">
                <span class="tms">n</span>
                <input v-model="transports[i]" placeholder="Свободен текст" />
                <span class="tms delete" @click="deleteRow(i)">b</span>
              </section>
            </div>
          </template>
        </section>

        <div class="add-row" @click="addRow">
          <span class="icon">+</span>
          <p>Добавяне на нов ред</p>
        </div>
      </main>
      <footer>
        <button :disabled="loading" @click="save">ЗАПАЗИ</button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  props: ["planning"],
  data() {
    return {
      loading: false,
      transports: [""],
    };
  },
  methods: {
    addRow() {
      this.transports.push("");
    },
    deleteRow(i) {
      this.transports.splice(i, 1);
    },
    isValid() {
      for (let t of this.transports) {
        if (!t) {
          this.$snotify.error("Не сте добавили име на транспорт.");
          return;
        }
      }

      return true;
    },
    save() {
      if (this.isValid()) {
        let p = this.planning;
        p.transport = this.transports;
        this.loading = true;
        const url = `${process.env.VUE_APP_BASE_URI}/planning/${p._id}`;

        this.$http
          .put(url, p)
          .then((a) => {
            if (a.data.errors) {
              console.log(a.data.errors);
              this.$snotify.error(this.$t("something-went-wrong"));
            } else {
              this.close(true);
              this.loading = false;
            }
          })
          .catch((error) => {
            console.log(error.response);
            this.$snotify.error(this.$t("something-went-wrong"));
          });
      }
    },
    close(update) {
      this.$emit("close", update);
    },
  },
  mounted() {
    if (this.planning.transport.length) {
      this.transports = this.planning.transport.slice();
    }
  },
};
</script>

<style lang="scss" scoped>
.modal {
  overflow: initial;
  max-width: 790px;
  user-select: none;
  width: calc(100% - 40px);
  header {
    align-items: center;
    background: #00408a;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    color: #fff;
    display: flex;
    height: 43px;
    justify-content: space-between;
    padding: 0 13px 0 25px;

    > div {
      align-items: center;
      display: flex;
      gap: 7px;
      .tms {
        font-size: 27px;
      }
      p {
        font-weight: 500;
        text-transform: uppercase;
      }
    }

    .close {
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }
  }

  > main {
    padding: 15px 25px;

    .rows {
      max-height: calc(50vh - 104px);
      overflow: auto;
    }
    .row {
      .input-wrap {
        display: flex;
        gap: 5px;
        background: #ffffff 0% 0% no-repeat padding-box;
        border: 1px solid #cecece;
        width: 100%;
        border-radius: 4px;
        align-items: center;
        padding: 0 10px;
        input {
          background-color: #fff;
          border-radius: 4px;
          border: none;
          padding: 0;
        }
        .tms {
          color: #003580;
          font-size: 22px;
        }
        .delete {
          align-items: center;
          color: #d58080;
          cursor: pointer;
          font-size: 14px;
          opacity: 0.5;
          &:hover {
            opacity: 1;
          }
        }
      }

      &:first-child {
        margin-bottom: 4px;
      }

      &:not(:first-child) {
        margin-top: 6px;
      }
    }
  }

  > footer {
    border-top: 1px solid #70707033;
    margin: 0 auto;
    padding: 12px;
    text-align: center;
    width: calc(100% - 11px);
    button {
      background: #0057bb;
      border: none;
      border-radius: 4px;
      color: #fff;
      cursor: pointer;
      font-size: 13px;
      font-weight: 500;
      height: 36px;
      width: 160px;

      &:disabled {
        cursor: default;
        opacity: 0.8;
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>
